module.exports = __webpack_public_path__ + "4ebffb46aa2c933fbcf60b48172569a0.jpg";